import { get, patch, post, upload } from "Service";

const CorporateList = (payload: any) => {
    console.log("payload", payload);
    const request = {
        subUrl: `Admin/GetAllUnverifiedCorporateUser?userType=${payload.userType}`,
        data: payload,
        isAuth: false,
    };
    return get(request);
}

const ProfessionalList = () => {
    const request = {
        subUrl: "Admin/GetAllUnverifiedProfessionalUser",
        isAuth: false,
    };
    return get(request);
}

const VerifyCorporate = (payload: any) => {
    const request = {
        subUrl: "Admin/verify-user",
        data: payload,
        isAuth: false,
    };
    return post(request);
}
const VerifyProfessional = (payload: any) => {
    const request = {
        subUrl: "Admin/verify-user",
        data: payload,
        isAuth: false,
    };
    return post(request);
}

const fetchCases = async () => {
    try {
        const request = {
            subUrl: "Admin/getAllCases",
            isAuth: false,
        };
        return await get(request);
    } catch (error) {
        console.error("Error fetching cases:", error);
        throw error;
    }
}
const fetchVerifyProfessionalList = async () => {
    try {
        const request = {
            subUrl: "Admin/getAllVerifiedProfessional",
            isAuth: false,
        };
        return await get(request);
    } catch (error) {
        console.error("Error fetching professional list:", error);
        throw error;
    }
}

const AssignCaseToProfessional = async (payload: any) => {
    try {
        const request = {
            subUrl: "Admin/assign-professional",
            data: payload,
            isAuth: false,
        };
        return await post(request);
    } catch (error) {
        console.error("Error assigning case to professional:", error);
        throw error;
    }
}

const OrderHistory = async (id : string) => {
    try {
        const request = {
            subUrl: `Cases/user/${id}`,
            isAuth: false,
        };
        return await get(request);
    } catch (error) {
        console.error("Error fetching order history:", error);
        throw error;
    }
}

const getProfile = (userId: string) => {
    const request = {
        subUrl: `get-user/${userId}`,
        isAuth: true,
    };
    return get(request);
}   

const ProfileUpdate = (userId: string, payload: any, userType: string) => {
     const formattedUserType =
    userType.charAt(0).toUpperCase() + userType.slice(1).toLowerCase();
    const request = {
        subUrl: `update-user/${userId}?userType=${formattedUserType}`,
        data: payload,
        isAuth: true,
    };
    return post(request);
}

const UploadProfilePicture = (file: File, userId: string) => {
     const fd = new FormData();
  fd.append("file", file, file.name);
    const request = {
        subUrl: `${userId}/upload-profile-picture`,
        data: fd,
        isAuth: true,
    };
    return upload(request);
}

const AdminApi = {
    CorporateList,
    VerifyCorporate,
    VerifyProfessional,
    ProfessionalList,
    fetchVerifyProfessionalList,
    AssignCaseToProfessional,
    fetchCases,
    OrderHistory,
    getProfile,
    ProfileUpdate,
    UploadProfilePicture
};

export default AdminApi;